import React from "react";

export const RemoveItemHelp = () => {
  return (
    <div>
      <div>Remove item help modal, explain removal types and how they affect waste</div>
    </div>
  );
};

export default RemoveItemHelp;
